<template>
  <section>
    <div class="mb-4" v-if="content.body && content.body.length > 0">
      <div class="headline" v-text="content.title"></div>
      <div
        class="subtitle-1 grey--text text--darken-2"
        v-text="content.subtitle"
      ></div>
    </div>
    <carousel-3d
      :perspective="0"
      :width="640"
      :height="360"
      :autoplay="true"
      :autoplay-timeout="interval * 1000"
      :display="3"
      :controlsVisible="true"
      :space="360"
      v-if="content.body && content.body.length > 0"
    >
      <slide v-for="(item, i) of content.body" :index="i" :key="i">
        <a>
          <img @click="openBanner(item)" :src="item.image" alt />
        </a>
      </slide>
    </carousel-3d>

    <!-- <v-window v-model="onboarding" mandatory @change="onChange">
      <v-window-item v-for="(item, idx) of content.body" :key="`card-${idx}`">
        <v-row :class="{'hoverable': item.url != null}" no-gutters @click="navigate(item)">
          <v-col cols="12">
            <v-img
              width="100%"
              contain
              class="grey"
              max-height="400px"
              :src="item.image"
              :lazy-src="item.image"
              aspect-ratio="1.79"
              :style="{borderRadius:'8px'}"
            >
              <template v-slot:placeholder>
                <v-row class="fill-height ma-0" align="center" justify="center">
                  <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
                </v-row>
              </template>
            </v-img>
          </v-col>
          <v-col cols="7">
            <div class="pa-4">
              <div class="headline" v-text="item.title"></div>
              <div class="subtitle-1" v-text="item.description"></div>
            </div>
          </v-col>
        </v-row>
      </v-window-item>
    </v-window>
    <v-item-group v-model="onboarding" class="text-center mt-4" mandatory>
      <v-item v-for="n in itemLength" :key="`btn-${n}`" v-slot:default="{ active, toggle }">
        <v-btn
          small
          :color="active ? 'primary': ''"
          :input-value="active"
          icon
          @click="onChange(); toggle()"
        >
          <v-icon x-small>fas fa-circle</v-icon>
        </v-btn>
      </v-item>
    </v-item-group>-->
  </section>
</template>

<script>
import { VCardText } from "vuetify/lib";
import { Carousel3d, Slide } from "vue-carousel-3d";

export default {
  name: "banner_slider",
  props: ["content"],
  components: { VCardText, Carousel3d, Slide },
  computed: {
    itemLength() {
      return this.content.body.length;
    },
  },
  data: () => ({
    onboarding: 0,
    timerId: null,
    interval: 10,
    autoPlay: true,
  }),
  mounted() {
    if (this.autoPlay) {
      this.play();
    }
  },
  methods: {
    play() {
      //   console.log(this.onboarding);
      this.timerId = setTimeout(() => {
        let idx = this.onboarding + 1;
        if (idx > this.itemLength - 1) {
          this.onboarding = 0;
        } else {
          this.onboarding = idx;
        }
        this.$nextTick(() => {
          this.play();
        });
      }, this.interval * 1000);
    },
    stop() {
      if (this.timerId != null) {
        clearTimeout(this.timerId);
      }
    },
    onChange() {
      //   console.log("change by user");
      if (this.autoPlay) {
        this.stop();
        this.play();
      }
    },
    navigate(item) {
      console.log("navigate");

      if (item.url != null) {
        this.$router.push(item.url);
      }
    },
    openBanner(item) {
      if (item.url) {
        window.open(item.url, "_blank");
      }
    },
  },
};
</script>